import {RootState} from "../../../store/reducer/root/RootState";
import * as React from "react";
import {connect} from "react-redux";
import SelectDictionaryItem from "../../admin/common/select/SelectDictionaryItem";

class SelectLeadType extends SelectDictionaryItem {
}

function mapStateToProps(state: RootState) {
	return {
		items: state.leadType.leadTypes
	}
}

export default connect(mapStateToProps)(SelectLeadType)